export default "{\n    \"restaurant\": \"Restaurante\",\n    \"vendor\": \"Proveedor\"\n}\n"